import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import {
  AccessResult,
  NO_ACCESS_MESSAGE,
  hasAnyRequiredActionsInAnySpace,
  hasAtLeastOneRequiredAction,
} from "utils/access";
import { Action } from "types/generated";

export const WORKER_POOL_CREATE_ACCESS_TYPES = [Action.SpaceAdmin, Action.WorkerPoolCreate];

/**
 * Hook that returns whether current user can create worker pools.
 * Without a spaceId, checks for SpaceAdmin or WorkerPoolCreate in at least one space. With a
 * spaceId, scopes the check to that specific space instead.
 * @returns {AccessResult} Object indicating if user can create worker pools and a message if not
 */
const useCanCreateWorkerPool = (spaceId?: string): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = spaceId
    ? hasAtLeastOneRequiredAction(WORKER_POOL_CREATE_ACCESS_TYPES, viewer, spaceId)
    : hasAnyRequiredActionsInAnySpace(WORKER_POOL_CREATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateWorkerPool;
